// FILE: src/services/api.js
// The only place that knows where the API lives (AD-8). Every request in the
// app goes through apiUrl()/apiFetch(); never read REACT_APP_API_URL elsewhere.
//
// URL rules:
// - REACT_APP_API_URL empty or not an absolute http(s) URL (e.g. "/") →
//   same-origin "/api/..." (production, and `npm start` via the CRA proxy).
// - REACT_APP_API_URL absolute (e.g. http://localhost:4000) → resolved against it.
// - Absolute http(s) paths are returned untouched.

const ABSOLUTE = /^https?:\/\//i;

function apiBase() {
  const base = (process.env.REACT_APP_API_URL || "").trim();
  return ABSOLUTE.test(base) ? base.replace(/\/+$/, "") : "";
}

export function apiUrl(path = "") {
  if (ABSOLUTE.test(path)) return path;
  // Collapse leading slashes: "//api/x" would be a protocol-relative URL
  // pointing at a host called "api".
  const relative = "/" + String(path).replace(/^\/+/, "");
  return apiBase() + relative;
}

export function apiFetch(path, options = {}) {
  return fetch(apiUrl(path), { credentials: "include", ...options });
}

/**
 * A file served with the web build itself — same origin as the page, never
 * the API host — e.g. /REVISION written by the deploy (src/services/appVersion.js).
 */
export function webFetch(path, options = {}) {
  const relative = "/" + String(path).replace(/^\/+/, "");
  return fetch((process.env.PUBLIC_URL || "") + relative, { credentials: "omit", ...options });
}
